import React from "react";

export default function RivePlaceholder({ width, height }) {
    return <svg
        className="rive__placeholder"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${width || 0} ${height || 0}`}
    ></svg>
}
